export default "__VITE_ASSET__caf84061__$_?component__"